import React, {useState} from "react";
import Title from "../components/Title";
import OrderDetails from "../components/OrderDetails";
import AEXProgressBar from "../components/AEXProgressBar";
import LatestUpdates from "../components/LatestUpdates";
import DeliveryActionButtons from "../components/DeliveryActionButtons";
import TrackPackageButton from "../components/TrackButton";
import FAQ from "../components/FAQ";
import OrderHeader from "../components/OrderHeader";
import { useLoaderData } from "react-router-dom";
import { mapOrderStatusId } from "../constants";
import CancellationInfo from "../components/CancellationInfo";
import PUDOLocationDetails from "../components/PUDOLocationDetails";
import ECommerceDeliveryOptions from "../components/ECommerceDeliveryOptions";
import { Col, Container, Row, Collapse, Button, Accordion } from "react-bootstrap";
import { Trans, useTranslation  } from "react-i18next";
import Alert from "react-bootstrap/Alert";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBell} from "@fortawesome/free-solid-svg-icons";
import AlertModal from "../modals/AlertModal.tsx";


function OrderDetailsPage() {
  useTranslation();// Required (from the useTranslation import, via react-i18next) to make the translations work from within this component.
  const [showAlertBanner, setShowAlertBanner] = useState(true);// for alerts
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  
  const { t, i18n: { language }} = useTranslation();
  const { order, trackingNumber, alertData } = useLoaderData();
  const isOrderCancelled =
    mapOrderStatusId(order.orderDetails.statusId) === "Cancelled";
  const isPUDOOrder = order.orderDetails.statusId === 24;
  const isECommerce = order.orderDetails.isECommerce;
  
  let contactAction = "https://www.appleexpress.com/contact";
  if (order.screenDetails.supportEmailAction === 1) {
    contactAction = `mailto:${order.screenDetails.supportEmail}`;
  }
  
  const alertClicked = (e) => {
    e.preventDefault();
    //console.log ('Alert Banner\'s \'More Info\' was clicked! ' + Math.random());
    setShowAlertPopup (true);
  };


  const alertPopupClosedClicked = (e) => {
    //console.log ('Alert popup\s was closed! ' + Math.random());
    setShowAlertPopup (false);
  };

  let options : Intl.DateTimeFormatOptions = {
    //weekday: "long",
    //year: "numeric",
    //month: "long",
    //day: "numeric",
    dateStyle: "medium",
    timeStyle: "medium"
  };
  // Translate using the browser's localization logic, as it does french better
  const generatedAtDateTime = alertData ? new Intl.DateTimeFormat(language.substring (0, 2), options).format(new Date(alertData.created)) : "";
  const expiresAtDateTime = alertData ? new Intl.DateTimeFormat(language.substring (0, 2), options).format(new Date(alertData.expires)) : "";
  
  return (
    <>
      <OrderHeader
        trackingNumber={trackingNumber}
        supportEmail={order.screenDetails.supportEmail}
        supportPhoneNumber={order.screenDetails.supportPhoneNumber}
      />
      {/*<div class="alert alert-danger alert-dismissible fade show" role="alert" style={{margin: 0}}>
        This is a danger alert with <a href="#" class="alert-link">an example link</a>. Give it a click if you like.
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>*/}
      {alertData && (
          <>
            <Alert variant={"danger"} show={showAlertBanner} onClose={() => setShowAlertBanner(false)} dismissible style={{marginBottom: 0}}>
              <Alert.Heading><FontAwesomeIcon icon={faBell} className="me-2"></FontAwesomeIcon> <Trans i18nKey="OrderDetails.alertHeading">Alert</Trans></Alert.Heading>
              {/*In your region, there has been reports of {alertData.eventTypeName}*/}{alertData.subject}. <Alert.Link onClick={e => alertClicked(e)}> <Trans i18nKey="OrderDetails.alertSubHeading">more info</Trans></Alert.Link>. {/*<button onClick={ e => alertClicked(e)}>asdf</button>*/}
            </Alert>
            
            {(showAlertPopup && <AlertModal alertDataP={alertData} showAlert={showAlertPopup} onCloseForParent={() => (alertPopupClosedClicked())}/>)}
            

            {/* Using Collapse... */}
            {/*<Collapse className="fixed-bottom bg-warning" in={show}>
              <div style={{padding: 10}}>
                <Button
                    className={"btn-close"}
                    style={{float: "right", display: "inline"}}
                    onClick={() => setShow(!show)}
                    aria-controls="example-collapse-text"
                    aria-expanded={show}
                >

                </Button>

                <h4><FontAwesomeIcon icon={faBell} className="me-2"></FontAwesomeIcon>Weather/Service Disruptions Statement</h4>
                In your region, there has been reports of <b>{alertData.eventTypeName}</b>.<br/>

                  <dl className="row" style={{marginBottom: 0}}>
                    <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}>Published</dt>
                    <dd className="col-sm-8">{generatedAtDateTime}</dd>
                  </dl>
                  <dl className="row" style={{marginBottom: 0}}>
                    <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}>Active Until</dt>
                    <dd className="col-sm-8">{expiresAtDateTime}</dd>
                  </dl>
                  <dl className="row" style={{marginBottom: 0}}>
                    <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}>Region Affected</dt>
                    <dd className="col-sm-8">{alertData.regionName}</dd>
                  </dl>
                  {alertData.description}                
              </div>
            </Collapse>*/}


            {/* Using Accordian... */}

            {/*<Accordion className="fixed-bottom" flush={true} bsPrefix="bg-warning" style={{width: "50%"}} defaultActiveKey="0">
              <Accordion.Item >
                <Accordion.Header>
                <div style={{padding: 10}}>
                  <h4><FontAwesomeIcon icon={faBell} className="me-2"></FontAwesomeIcon>Weather/Service Disruptions Statement</h4>
                  In your region, there has been reports of <b>{alertData.eventTypeName}</b>.
                </div>
                  <Button
                      className={"btn-close"}
                      style={{float: "right", display: "inline"}}
                      onClick={() => setShow(!show)}
                      aria-controls="example-collapse-text"
                      aria-expanded={show}
                  >

                  </Button>
                </Accordion.Header>
                <hr style={{margin: 0}}/>
                <Accordion.Body>
                  <div style={{padding: 10}}>
                  <dl className="row" style={{marginBottom: 0}}>
                    <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}>Published</dt>
                    <dd className="col-sm-8">{generatedAtDateTime}</dd>
                  </dl>
                  <dl className="row" style={{marginBottom: 0}}>
                    <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}>Active Until</dt>
                    <dd className="col-sm-8">{expiresAtDateTime}</dd>
                  </dl>
                  <dl className="row" style={{marginBottom: 0}}>
                    <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}>Region Affected</dt>
                    <dd className="col-sm-8">{alertData.regionName}</dd>
                  </dl>
                  {alertData.description}
                </div> </Accordion.Body>
                </Accordion.Item>
            </Accordion>  */}          
          </>
      )}
      <TrackPackageButton caption={t('TrackButton.defaultCaption')} trackingNumber={trackingNumber} data={order} />

      <Container fluid>
        <Row className="ms-0 me-0">
          <Col xs={12} lg={8}>
            <Title data={order} />
            <DeliveryActionButtons data={order} />
            {isOrderCancelled && (
              <CancellationInfo trackingNumber={trackingNumber} data={order} />
            )}
            {!isOrderCancelled && <OrderDetails data={order}/>}
            {!isOrderCancelled && <AEXProgressBar data={order} />}
            <LatestUpdates data={order} />
            <p className="mt-4">
              {!isECommerce && contactAction !== "mailto:" && (
              <Trans i18nKey="OrderDetails.contactUs">
                For more information please&nbsp;
                <a target="_blank" href={contactAction} rel="noreferrer">
                  contact us.
                </a>
              </Trans>
              )}
              
            </p>
          </Col>
          <Col xs={12} lg={4}>
            {isPUDOOrder && <PUDOLocationDetails data={order}/>}
            {isECommerce && <ECommerceDeliveryOptions data={order}/>}
            <FAQ isECommerce={isECommerce}/>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default OrderDetailsPage;
